// extracted by mini-css-extract-plugin
export var product_detail = "product_details_section-module--product_detail--3906b";
export var section_product_details = "product_details_section-module--section_product_details--d3c5b";
export var text = "product_details_section-module--text--24ef4";